import { zExt } from "@redotech/redo-model/common/zod-util";
import { z } from "zod/v4";

export enum CreateGiftReceiptRequestErrorCode {
  UNAUTHORIZED = "UNAUTHORIZED",
  INVALID_INPUT = "INVALID_INPUT",
  FAILED_TO_CREATE_REQUEST = "FAILED_TO_CREATE_REQUEST",
}

export const createGiftReceiptRequest = {
  input: z.object({
    email: z.string().email(),
    giftInformation: z.string().min(1),
  }),
  output: z.object({ id: zExt.objectId() }),
};
